const {getSiteCssVariables, getComponentCssVariables} = require('./dist/runtime-cjs/standalone');

module.exports = {
  getSiteCssVariables,
  getComponentCssVariables,
};
